module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/permissions/permissions.component.css
// module id = ./src/app/permissions/permissions.component.css
// module chunks = main